import React from 'react'
import { NavLink } from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <div class="container">
      <div className="text1 d-flex justify-content-center flex-column align-items-center page-length">
        <h1>Page not found</h1>
        <br />
        <div className="text-center mt-3">
          <NavLink to='/' className='btn-modern btn-primary text-decoration-none'>
            <i className="bi bi-arrow-left me-2"></i>
            <span>Back Home</span>
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage